import { baseApi, defaultQueryFreshness } from "./baseApi";

export const reviewsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReviews: builder.query<unknown, string>({
      query: (userId) => ({ url: `/reviews/${userId}`, method: "GET" }),
      providesTags: (_res, _err, userId) => [{ type: "Reviews", id: `user:${userId}` }],
      ...defaultQueryFreshness,
    }),
  }),
});

export const { useGetReviewsQuery } = reviewsApi;
